export const aciInfoAlert = {
    iconName: 'info-alert',
    svgDef: {
        attr: { fill: 'none', viewBox: '0 0 24 24' },
        path: [
            {
                attr: {
                    'fill-rule': 'evenodd',
                    'clip-rule': 'evenodd',
                    d: 'M11.195 2.02a10.032 10.032 0 00-8.713 6.884A9.561 9.561 0 002 12.001c0 1.591.325 2.998 1.021 4.417a9.75 9.75 0 001.906 2.66 9.752 9.752 0 002.66 1.906 9.987 9.987 0 003.32.972c.457.054 1.738.054 2.193 0a10.02 10.02 0 004.917-1.952 10.019 10.019 0 003.942-6.907c.055-.46.054-1.739 0-2.192a10.031 10.031 0 00-6.858-8.425 9.618 9.618 0 00-2.219-.452 14.947 14.947 0 00-1.687-.008zm.224 1.054c-.936.091-1.458.19-2.12.404a8.8 8.8 0 00-3.614 2.204c-1.45 1.45-2.32 3.251-2.57 5.33-.03.245-.04.473-.04.99 0 .718.025 1.016.13 1.596a8.88 8.88 0 002.48 4.723c1.447 1.448 3.256 2.32 5.33 2.57.451.054 1.527.054 1.979 0 1.804-.218 3.395-.9 4.757-2.041a8.962 8.962 0 003.052-5.252c.105-.578.13-.878.13-1.597s-.025-1.019-.13-1.596a8.96 8.96 0 00-5.558-6.738 9.137 9.137 0 00-2.24-.554c-.271-.033-1.374-.06-1.586-.04z',
                    fill: 'currentColor',
                },
            },
            {
                attr: {
                    d: 'M12.486 16.652c-.055.118-.199.255-.3.287a.854.854 0 01-.214.013.486.486 0 01-.456-.311c-.043-.096-.043-.119-.044-3.67 0-2.678.006-3.594.025-3.657a.644.644 0 01.283-.318.663.663 0 01.448 0c.109.05.25.209.283.318.019.063.025.98.025 3.657v3.574l-.05.107zM12.776 6.982a.91.91 0 01-.575.484 1.108 1.108 0 01-.245.012.843.843 0 01-.724-.496c-.061-.13-.068-.163-.068-.346 0-.182.007-.216.068-.345a.848.848 0 011.544 0c.061.13.068.163.068.345 0 .183-.007.216-.068.346z',
                    fill: 'currentColor',
                },
            },
        ],
    },
};
